import { observer } from 'mobx-react-lite';

import { DataGridTariffRow } from './create-table-grid-data';
import { useCellEditor } from './edit-cell-provider';

type TariffPriceCellProps = {
  row: DataGridTariffRow;
  zoneId: number;
};

export const TariffPriceCell = observer(
  ({ row, zoneId }: TariffPriceCellProps) => {
    const callEditor = useCellEditor();
    const tariff = callEditor.dataMap.getRecord({
      tariffTypeId: row.tariffTypeId,
      trainTypeId: row.trainTypeId,
      zoneId,
    });

    return tariff?.isEmpty ? null : <>{tariff?.price}</>;
  },
);
